import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Loader2 } from 'lucide-react'
import { Card, CardContent } from './card'

interface EnhancementSuggestion {
  visual_element: string
  visual_changes: string
  expected_impact: string
  implementation_priority: number
}

interface EnhancementSuggestionsProps {
  suggestions: EnhancementSuggestion[]
  userGoals: string
  enhancedImage: string | null
  enhancedImageLoading: boolean
  isEnhancedImageOpen: boolean
  onGenerateEnhancedImage: () => void
  onEnhancedImageOpenChange: (open: boolean) => void
}

export const EnhancementSuggestions = ({
  suggestions,
  userGoals,
  enhancedImage,
  enhancedImageLoading,
  isEnhancedImageOpen,
  onGenerateEnhancedImage,
  onEnhancedImageOpenChange,
}: EnhancementSuggestionsProps) => {
  return (
    <Card>
      <CardContent>
        <h3 className="pb-2 font-semibold">Enhancement Suggestions</h3>
        <div className="mb-4">
          <h4 className="text-sm font-semibold">User Goals</h4>
          <p>{userGoals}</p>
        </div>
        <ul className="space-y-2">
          {suggestions.map((suggestion, index) => (
            <li key={index}>
              <h5 className="text-xs font-semibold pt-2 mb-1">
                {suggestion.visual_element}
              </h5>
              <div className="mb-2">
                {suggestion.visual_changes} {suggestion.expected_impact}
              </div>
            </li>
          ))}
        </ul>
        {/* Enhanced image generation - only for internal users */}
        <Button
          onClick={onGenerateEnhancedImage}
          className="w-full cursor-pointer"
          disabled={enhancedImageLoading}
        >
          Generate Enhanced Image
          {enhancedImageLoading && (
            <Loader2 className="w-4 h-4 animate-spin" />
          )}
        </Button>

        {enhancedImage && (
          <Dialog
            open={isEnhancedImageOpen}
            onOpenChange={onEnhancedImageOpenChange}
          >
            <DialogContent className="sm:max-w-3xl">
              <DialogHeader>
                <DialogTitle>Enhanced Image</DialogTitle>
              </DialogHeader>
              <img
                src={enhancedImage}
                className="w-full h-auto rounded-md"
                alt="Enhanced Image"
              />
            </DialogContent>
          </Dialog>
        )}
      </CardContent>
    </Card>
  )
}
